import { ContentActionNotification } from '~commonInfra/contentActions/ContentActionNotification';
import {openReactActionDialog} from '~commonInfra/dialogs/ReactActionDialog';
import {TabDialogWidth} from '~commonInfra/dialogs/style/TabDialogWidth';

import {Messages} from '../../codegen/Localize';
import { IError } from '../../httpClient/serverApi/types/IError';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { INamedItemInfo } from '../../ts/models/resourceInfoParts';
import {
  EditRemoteRefreshExpectedDurationDialogBody,
  EditRemoteRefreshExpectedDurationDialogProps,
  EditRemoteRefreshExpectedDurationDialogState,
} from '../components/editRemoteRefresh/EditRemoteRefreshExpectedDurationDialog';
import { IRemoteRefreshScheduleInfo } from '../models/IRemoteRefreshScheduleInfo';
import {RemoteRefreshSchedules} from '../resources/RemoteRefreshSchedules';

export namespace EditRemoteRefreshExpectedDurationAction {

  export class RemoteRefreshScheduleExpectedDurationViewModel {

    public hours: number;
    public minutes: number;

    // The default is 24 hours
    constructor(expectedRefreshDurationInSec: number = 3600 * 24) {
      this.hours = Math.floor(expectedRefreshDurationInSec / 3600);
      this.minutes = Math.floor((expectedRefreshDurationInSec % 3600) / 60);
    }
  }

  export function execute(
      item: INamedItemInfo,
      currentExpectedDurationInfo: IRemoteRefreshScheduleInfo) {

      // Initialize
      const initialViewModel = new RemoteRefreshScheduleExpectedDurationViewModel(currentExpectedDurationInfo.expectedRefreshDuration);

      const initialBodyProps = {
        currentExpectedDurationInfo: currentExpectedDurationInfo,
      };

      const initialDialogState = {
        hours: initialViewModel.hours.toString(),
        minutes: initialViewModel.minutes.toString(),
        errorMessage: '',
      };

      const title = Messages.editRemoteRefreshExpectedDurationDialogTitle();

      const dialogInstance = openReactActionDialog<EditRemoteRefreshExpectedDurationDialogProps, EditRemoteRefreshExpectedDurationDialogState, IResult>({
        bodyComponent: EditRemoteRefreshExpectedDurationDialogBody,
        actionName: Messages.editRemoteRefreshExpectedDurationActionName(),
        action: (_, state, updateDialogState) => {
          currentExpectedDurationInfo.expectedRefreshDuration = parseInt(state.hours) * 3600 + parseInt(state.minutes) * 60;
          return RemoteRefreshSchedules.updateExpectedDuration(item.id, currentExpectedDurationInfo)
            .then((result: IResult) => {
            if (result.errors && result.errors.length) {
              const errorMessage = errorMessageFor(result.errors[0]);
              updateDialogState({ errorMessage });
              return Promise.reject();
            } else {
              ContentActionNotification.displaySuccessToast(
                Messages.editRemoteRefreshExpectedDurationSuccess()
              );
            }
          });
        },
        actionDisabled: (props, state) => {
          const hours = parseInt(state.hours);
          const minutes = parseInt(state.minutes);

          return isNaN(hours)|| isNaN(minutes) || (hours < 0 || hours > 9999) || (minutes < 0 || minutes > 60)
            || !hasRefreshDurationChanged(props.currentExpectedDurationInfo, hours,minutes);
        },

        dialogWidth: TabDialogWidth.width500px,
        dismissDialogOnActionFailed: false,
        initialBodyProps,
        initialDialogState,
        title
      });

    return Promise.resolve(dialogInstance.result);
  }

  function errorMessageFor(error: IError) {
    return Messages.errorUnknown();
  }

  function hasRefreshDurationChanged(currentExpectedDurationInfo: IRemoteRefreshScheduleInfo, hours: number, minutes: number) {
    return currentExpectedDurationInfo.expectedRefreshDuration !== (hours*3600 + minutes*60);
  }
}
